import Meta from 'components/common/Meta';
import Layout from 'components/common/NewLayout';
import FaqList from 'components/faq/FaqList';
import Inquiry from 'components/faq/Inquiry';
import Main from 'components/faq/Main';
import Menu from 'components/faq/Menu';
import useFaq from 'core/hooks/useFaq';
import React from 'react';
import { useParams } from 'react-router-dom';

const Faq = () => {
  const { type, category } = useParams();
  const { typeList, menuList, categoryList } = useFaq();

  return (
    <Layout theme="white">
      <Meta title="FAQ | 몰파이" ogTitle="FAQ | 몰파이" />
      <Main title="자주 묻는 질문" subTitle={typeList[type]} isSearch={true}>
        <Menu menus={menuList[type]} type={type} category={category} />
        <FaqList list={categoryList[type][category]} />
      </Main>
      <Inquiry />
    </Layout>
  );
};

export default Faq;
